// 15 October 2026, 00:00 Asia/Kuala_Lumpur (UTC+08:00).
export const PDPA_V2_CUTOFF = Date.parse("2026-10-14T16:00:00Z");
export const PDPA_POLICY_KEY = "v2-2026-10-15";
export const PDPA_SNOOZE_MS = 30 * 24 * 60 * 60 * 1000;

export function needsPDPAConsent(acceptedAt) {
  if (acceptedAt === undefined) return false; // Status has not loaded.
  if (acceptedAt === null) return true;
  const timestamp = Date.parse(acceptedAt);
  return Number.isFinite(timestamp) && timestamp < PDPA_V2_CUTOFF;
}

export function snoozeKey(userId) {
  return `hiredly:pdpa:${PDPA_POLICY_KEY}:${userId}`;
}

export function isPDPASnoozed(userId, now = Date.now()) {
  try {
    const expiry = Number(window.localStorage.getItem(snoozeKey(userId)));
    return (
      Number.isFinite(expiry) && expiry > now && expiry <= now + PDPA_SNOOZE_MS
    );
  } catch {
    return false;
  }
}

export function snoozePDPA(userId, now = Date.now()) {
  try {
    window.localStorage.setItem(
      snoozeKey(userId),
      String(now + PDPA_SNOOZE_MS)
    );
  } catch {
    // Storage may be blocked; dismissal still allows portal access.
  }
}

export function clearPDPASnooze(userId) {
  try {
    window.localStorage.removeItem(snoozeKey(userId));
  } catch {
    // Backend acceptance remains authoritative when storage is unavailable.
  }
}
